export const BASE_API_LINK =
  "https://be-e-commerce-image-search-price-predict-git-main-atharva-77.vercel.app";
